

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const SENDCONNECTIONREQUEST= createAsyncThunk(
  "sendConnectionRequest/sendConnectionRequest",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const sendConnectionRequestSlice = createSlice({
  name: "sendConnectionRequestSlice",
  initialState: {
    sendConnectionRequest: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfsendConnectionRequest: (state) => {
        state.sendConnectionRequest.loading = false
        state.sendConnectionRequest.error = false
        state.sendConnectionRequest.data = []
        state.sendConnectionRequest.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(SENDCONNECTIONREQUEST.fulfilled, (state, action) => {
      state.sendConnectionRequest = {
        ...state.sendConnectionRequest,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(SENDCONNECTIONREQUEST.pending, (state, action) => {
      state.sendConnectionRequest = {
        ...state.sendConnectionRequest,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(SENDCONNECTIONREQUEST.rejected, (state, action) => {
      state.sendConnectionRequest = {
        ...state.sendConnectionRequest,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const sendConnectionRequestAction = {
    SENDCONNECTIONREQUEST,
};

export { sendConnectionRequestAction };
export default sendConnectionRequestSlice.reducer;
export const {setInitialStateOfsendConnectionRequest} = sendConnectionRequestSlice.actions